<template>
  <v-dialog :model-value="isOpen" opacity = "0.5" persistent>
    <template #default>
      <div class="d-flex justify-center mt-6">
        <v-card
          :width="mobile ? '90%' : '65%'"
          max-height="78vh"
          color="white"
          elevation="3"
          class="d-flex flex-column"
        >
          <v-toolbar flat density="compact" color="white">
            <div class="d-flex align-center">
              <v-btn icon color="primary" @click="close()">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </div>
            
            <v-chip variant="tonal" color="primary" v-if="orderModel.orderId">
              ID: {{ orderModel.orderId }}
            </v-chip>
    
            <v-spacer />
          </v-toolbar>

          <v-form ref="form" class="card-scroll">
            <v-row dense class="pb-8 pl-8 pr-8">
              <v-col cols="12">
                <v-tabs v-model="activeTab" color="primary" density="compact" align-tabs="center" grow>
                  <v-tab value="0">Dados do pedido</v-tab>
                  <v-tab value="1">Produtos</v-tab>
                </v-tabs>
                
                <v-window v-model="activeTab" :touch="false" class="mt-4" style="min-height: 55vh;">
                  <v-window-item value="0">
                    <v-row>
                      <v-col cols="12">
                        <v-sheet >
                           <div class="d-flex align-center mb-2 flex-wrap">
                            <v-icon color="primary" class="mr-2" size="small">mdi-information-variant-circle-outline</v-icon>
                            <span class="text-subtitle-1 text-primary" style="color: #1F4529;">Informações gerais</span>
                            <v-spacer></v-spacer>
                            <span>{{ formatDateTime(orderModel.orderDate) }}</span>
                          </div>
                        </v-sheet>
                        <v-divider class="mb-3"></v-divider>
                      </v-col>
                        
                      <v-col cols="12" md="7" class="mt-n2">
                        <BaseAutoComplete
                          v-model="orderModel.customerId"
                          store-module="customer"
                          items-state="lstCustomer"
                          :item-title="item => `${item.customerId} - ${item.customerName}`"
                          item-value="customerId"
                          action="search"
                          :label="customerOption"
                          :readonly="order.isUpdate"
                          :rules="[v => !!v || 'Campo obrigatório']"
                        />
                      </v-col>
  
                      <v-col cols="12" md="3" sm="5" class="mt-n2">
                        <div>
                          <v-autocomplete
                            v-model="orderModel.operation"
                            :items="operationTypeItems"
                            item-title="title"
                            item-value="value"
                            rounded
                            variant="outlined"
                            density="compact"
                            label="Operação"
                            :readonly="order.isUpdate"
                            :rules="[v => !!v || 'Campo obrigatório']"
                          ></v-autocomplete>
                        </div>
                      </v-col>
                      
                      <v-col cols="12" md="4" sm="6" class="mt-n2">
                        <BaseAutoComplete
                          v-model="orderModel.stockId"
                          store-module="stock"
                          items-state="lstStock"
                          :item-title="item => `${item.stockId} - ${item.stockName}`"
                          item-value="stockId"
                          action="search"
                          :label="stockOption"
                          :readonly="order.isUpdate"
                          :rules="[v => !!v || 'Campo obrigatório']"
                        />
                      </v-col>
  
                      <v-col cols="12" md="5" sm="6" class="mt-n2">
                        <BaseAutoComplete
                          v-model="orderModel.sellerId"
                          store-module="seller"
                          items-state="lstSeller"
                          :item-title="item => `${item.sellerId} - ${item.sellerName}`"
                          item-value="sellerId"
                          action="search"
                          label="Vendedor"
                          :readonly="order.isUpdate"
                          :rules="[v => !!v || 'Campo obrigatório']"
                        />
                      </v-col>
  
                      <v-col cols="12">
                        <v-sheet class="mt-n6">
                           <div class="d-flex align-center mb-2">
                            <v-icon color="primary" class="mr-2" size="small">mdi-cash-multiple</v-icon>
                            <span class="text-subtitle-1 text-primary" style="color: #1F4529;">Pagamento</span>
                          </div>
                        </v-sheet>
                        <v-divider class="mb-3"></v-divider>
                      </v-col>
          
                      <v-col cols="12" md="5" sm="6" class="mt-n2">
                        <BaseAutoComplete
                          v-model="orderModel.paymentId"
                          store-module="payments"
                          items-state="lstPayments"
                          :item-title="item => `${item.paymentId} - ${item.paymentName}`"
                          item-value="paymentId"
                          action="search"
                          label="Forma de pagamento"
                          :readonly="order.isUpdate"
                          :rules="[v => !!v || 'Campo obrigatório']"
                        />
                      </v-col>
                      <v-col cols="12" md="3" sm="6" class="mt-n2">
                        <div>
                          <v-text-field
                            :model-value="formatCurrency(orderModel.totalValue)"
                            label="Valor total"
                            variant="outlined"
                            rounded
                            color="primary"
                            density="compact"
                            readonly
                          />
                        </div>
                      </v-col>
                    </v-row>
                  </v-window-item>
  
                  <v-window-item value="1">
                    <v-row>
                      <v-col cols="12">
                        <v-sheet >
                           <div class="d-flex align-center mb-2">
                            <v-icon color="primary" class="mr-2" size="small">mdi-sprout</v-icon>
                            <span class="text-subtitle-1 text-primary" style="color: #1F4529;">Produtos</span>
                          </div>
                        </v-sheet>
                        <v-divider class="mb-2"></v-divider>
                      </v-col>
  
                      <v-col cols="12">
                        <v-row dense>
                          <v-col cols="12" md="6" sm="10" class="mt-n2">
                            <div class="d-flex justify-center">
                              <BaseAutoComplete
                                v-model="product.productId"
                                store-module="product"
                                items-state="lstProduct"
                                :item-title="item => `${item.productId} - ${item.productName}`"
                                item-value="productId"
                                action="search"
                                label="Produto"
                                :readonly="order.isUpdate"
                              />
                            </div>
                          </v-col>
                          <v-col cols="12" md="2" sm="4" class="mt-n2">
                            <div>
                              <v-text-field
                                v-model.number="quantity"
                                label="Quantidade"
                                variant="outlined"
                                rounded
                                color="primary"
                                density="compact"
                                :readonly="order.isUpdate"
                                @keyup.enter="focusUnitPrice()"
                              />
                            </div>
                          </v-col>
                          <v-col cols="12" md="3" sm="6" class="mt-n2">
                            <div>
                              <v-text-field
                                ref="unitPrice"
                                v-model="formattedValue"
                                prefix="R$"
                                label="Valor unitário"
                                variant="outlined"
                                rounded
                                color="primary"
                                density="compact"
                                @keyup.enter="addItems()"
                                :readonly="order.isUpdate"
                              />
                            </div>
                          </v-col>
                          <v-col cols="12" md="1" sm="1" class="mt-n2">
                            <v-btn
                              rounded
                              color="primary"
                              @click="addItems()"
                              :disabled="order.isUpdate"
                            >
                              <v-icon>mdi-plus</v-icon>
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12" class="mt-n2 mb-10">
                        <v-data-table
                            :headers="order.headersItems"
                            :items="order.lstOrderItems"
                            no-data-text="Nenhum produto adicionado"
                            class="card-scroll"
                            :items-per-page="-1"
                            hide-default-footer
                            :disabled="order.isUpdate"
                        >
                            <template #headers="{ columns }">
                                <tr>
                                    <th v-for="column in columns" :key="column.key" style="text-align: center; font-weight: 600;">
                                        {{ column.title }}
                                    </th>
                                </tr>
                            </template>
                            <template v-slot:[`item.unitPrice`]="{ item }">
                              {{ formatCurrency(item.unitPrice) }}
                            </template>
                            <template v-slot:[`item.actions`]="{ item }">
                                <v-icon color="red" icon="mdi-delete"  @click="removeItem(item.productId)" :disabled="order.isUpdate"></v-icon>
                            </template>
                        </v-data-table>
                      </v-col>
                    </v-row>
                  </v-window-item>
                </v-window>
              </v-col>
            </v-row>
          </v-form>
          <v-card-actions class="mt-n8 pb-6 pr-6">
            <div class="d-flex flex-column flex-md-row w-100 justify-end">
              <v-btn
                rounded
                variant="flat"
                @click="close()"
              >
                Cancelar
              </v-btn>
              <v-btn
                rounded
                color="primary"
                class="ml-2"
                variant="elevated"
                @click="save()"
                :disabled="order.isUpdate"
              >
                Salvar  
              </v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </div>
    </template>
  </v-dialog>
</template>


<script>
import { useDisplay } from 'vuetify'
import { OperationType } from '@/enums/operationType';
import { DialogType } from '@/enums/dialogType'
import BaseAutoComplete from '@/components/BaseAutoComplete.vue';

export default {
  setup () {
    const { mobile } = useDisplay()
    return { mobile }
  },
  data: () => ({
    orderId: '',
    quantity: '',
    unitPrice: 0,
    activeTab: 0,

  }),
  components: {
    BaseAutoComplete
  },
  computed: {
    order: {
      get() {
        return this.$store.state.order
      }
    },
    orderModel: {
      get() {
          return this.$store.state.order.order
      },
    },
    stock: {
      get() {
          return this.$store.state.stock
      }
    },
    product: {
      get() {
          return this.$store.state.product
      }
    },
    customer: {
      get() {
          return this.$store.state.customer
      }
    },
    isOpen: {
      get() {
        return Boolean(this.$route.params.orderId || this.$route.name == 'NewOrder')
      },
      set(value) {
        if (!value) {
          this.$router.push({ name: 'OrderGrid' })
        }
      }
    },
    category: {
      get() {
          return this.$store.state.category
      }
    },
    seller: {
      get() {
          return this.$store.state.seller
      }
    },
    payments: {
      get() {
          return this.$store.state.payments
      }
    },
    operationTypeItems() {
      return Object.entries(OperationType)
        .filter(([, value]) => value !== OperationType.Ambos)
        .map(([key, value]) => ({
          value,
          title: key
        }))
    },
    stockOption() {
      return this.orderModel.operation === OperationType.Venda
        ? 'Estoque de saída'
        : 'Estoque de entrada'
    },
    customerOption() {
      return this.orderModel.operation === OperationType.Venda
        ? 'Cliente'
        : 'Fornecedor'
    },
    formattedValue: {
      get() {
        if (this.unitPrice === null || this.unitPrice === undefined) 
          return ''

        return this.unitPrice.toLocaleString('pt-BR', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        })
      },
      set(value) {
        const numeric = value.replace(/\D/g, '')

        this.unitPrice = Number(numeric) / 100
      }
    },
    totalOrderValue() {
      return this.order.lstOrderItems.reduce((sum, item) => {
        return sum + (Number(item.quantity) * Number(item.unitPrice))
      }, 0)
    }
  },
  methods: {
    async save() {
      const { valid } = await this.$refs.form.validate()
      if (!valid) return

      const success = await this.$store.dispatch("order/save")
      if (success) {
        this.$store.commit('order/setShouldReload', true)
        this.close()
      }
    },
    cleanFields() {
        this.product.productId = null
        this.quantity = ''
        this.unitPrice = 0
    },
    close() {
        this.$router.push({ name: 'OrderGrid' })
        this.cleanFields()
        this.activeTab = 0
        this.$store.commit('order/setOrder', { operation: OperationType.Venda})
        this.$store.commit('order/setLstOrderItems', [])
    },
    async deleteOrder() {
      const success = await this.$store.dispatch("order/delete")
      if (success) {
        this.$store.commit('order/setShouldReload', true)
        this.close()
      }
    },
    addItems() {
        const product = this.product.lstProduct.find(
            p => p.productId === this.product.productId
        )

        if (!product) {
          this.$store.dispatch('systemDialog/show', {
              type: DialogType.WARNING,
              message: 'Selecione um produto'
          }, { root: true })
          return
        }


        if (!this.quantity || this.quantity <= 0) {
          this.$store.dispatch('systemDialog/show', {
              type: DialogType.WARNING,
              message: 'Adicione uma quantidade'
          }, { root: true })
          return
        }

        const productAlreadyAdded = this.order.lstOrderItems.findIndex(
          p => p.productId === this.product.productId
        )

        if (productAlreadyAdded === -1 || this.order.lstOrderItems[productAlreadyAdded]?.unitPrice != this.unitPrice ) {
          this.order.lstOrderItems.push({
            productId: product.productId,
            productName: product.productName,
            quantity: this.quantity,
            unitPrice: this.unitPrice
          })
        } else {
          this.order.lstOrderItems[productAlreadyAdded].quantity += this.quantity
        }

        this.cleanFields()
    },
    removeItem(itemId) {
        const index = this.order.lstOrderItems.findIndex(item => item.productId === itemId)
        this.order.lstOrderItems.splice(index, 1)
    },
    formatCurrency(value) {
      if (value === null || value === undefined) return 'R$ 0,00'

      return Number(value).toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL'
      })
    },
    formatDateTime(date) {
      if (!date) return ''

      return new Date(date).toLocaleString('pt-BR', {
        dateStyle: 'short',
        timeStyle: 'short'
      })
    },
    focusUnitPrice() {
      this.$nextTick(() => {
        this.$refs.unitPrice?.focus()
      })
    },
  },
  watch: {
    '$route.params.orderId': {
      immediate: true,
      async handler(id) {
        if(id) {
          await this.$store.dispatch('order/find', id)
          await this.$store.dispatch('order/findList', id)

          if (this.orderModel.customerId) {
            await this.$store.dispatch('customer/find', this.orderModel.customerId)
            if (!this.customer.lstCustomer.find(c => c.customerId === this.orderModel.customerId)) {
              this.customer.lstCustomer.unshift(this.customer.customer)
            }
          }
          if (this.orderModel.stockId) {
            await this.$store.dispatch('stock/find', this.orderModel.stockId)
            if (!this.stock.lstStock.find(s => s.stockId === this.orderModel.stockId)) {
              this.stock.lstStock.unshift(this.stock.stock)
            }
          }
          if (this.orderModel.sellerId) {
            await this.$store.dispatch('seller/find', this.orderModel.sellerId)
            if (!this.seller.lstSeller.find(s => s.sellerId === this.orderModel.sellerId)) {
              this.seller.lstSeller.unshift(this.seller.seller)
            }
          }
          if (this.orderModel.paymentId) {
            await this.$store.dispatch('payments/find', this.orderModel.paymentId)
            if (!this.payments.lstPayments.find(p => p.paymentId === this.orderModel.paymentId)) {
              this.payments.lstPayments.unshift(this.payments.payment)
            }
          }
          if (this.product.productId) {
            await this.$store.dispatch('product/find', this.product.productId)
            if (!this.product.lstProduct.find(p => p.productId === this.product.productId)) {
              this.product.lstProduct.unshift(this.product.product)
            }
          }

        } else {
          this.$store.commit('order/initForm')
        }
      }
    },
    totalOrderValue: {
      immediate: true,
      handler(value) {
        this.$store.commit('order/setTotalValue', value)
      }
    }
  }
}
</script>


<style>

.card-scroll {
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: thin;
}
</style>